import { render, staticRenderFns } from "./TemporaryAssistanceInformations.vue?vue&type=template&id=a80e151c&scoped=true"
import script from "./TemporaryAssistanceInformations.vue?vue&type=script&lang=js"
export * from "./TemporaryAssistanceInformations.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAssistanceInformations.vue?vue&type=style&index=0&id=a80e151c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e151c",
  null
  
)

export default component.exports